export default "__VITE_ASSET__$m_torC$__"